import data from "./types/data";
import meta from "./types/meta";
import query from "./types/query";

const initialState = {
    data,
    query,
    meta
};

const beefOverridesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'beefOverrides/update':
            return {
                ...state,
                ...action.payload
            };

        case 'beefOverrides/clear':
            return initialState;

        default:
            return state;
    }
};

export default beefOverridesReducer;